import React from 'react';
import {
  Box,
  Typography,
  makeStyles,
} from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    banner: {
      position: 'absolute',
      width: '100%',
      height: '85%',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(0, 0, 0, .95)',
      zIndex: 1,
    },
    message: {
      fontSize: 22,
      width: '90%',
      textAlign: 'center'
    },
  };
});

const TulumShowNotAvailableOverlay = () => {
  const classes = useStyles();

  return (
    <Box
      alignItems="center"
      className={classes.banner}
      display="flex"
      justifyContent="center"
    >
      <Typography className={classes.message}>
        The content is so hot that even the camera needed to take a breath! We'll be right back!
      </Typography>
    </Box>
  );
};

export default TulumShowNotAvailableOverlay;
